<template>
  <card-canvas class="outbound-webhooks" size="large">
    <card-canvas-two-deep-breadcrumb
      :parent-route="RouteAssistant.getDevelopersHomeRoute($route.params.accountId)"
      parent-name="Developer Center"
      child-name="Webhooks" />
    <h2>Webhooks</h2>
    <p v-if="$screen.isTabletOrMobile($mq)">
      The Developer Center is only available on desktop sized screens.
    </p>
    <template v-else>
      <p>
        When you add endpoints, DoneDone will deliver a JSON payload based on the events selected from our <strong>Events Catalog</strong> below.
        Have any questions on setting up webhooks? Just 
        <a href="https://www.donedone.com/help-center" target="_blank" class="just-a-link">contact us</a> at our support center.
      </p>
      <div class="svix-wrapper"> 
        <loading-placeholder v-if="isLoading" :lines="20" />
        <iframe
          v-else
          :src="webhooksManagementUrl"
          style="width: 100%; height: 100%; border: none;"
          allow="clipboard-write"
          loading="lazy"
        />
      </div>
    </template>
  </card-canvas>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */
import ProfileAPI from '@/api/modules/profile.api'
import CardCanvasTwoDeepBreadcrumb from '@/components/global/breadcrumb/card-canvas-two-deep-breadcrumb.vue'

export default defineComponent({
  components: {
    CardCanvas,
    CardCanvasTwoDeepBreadcrumb,
  },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      webhooksManagementUrl: '',
    }
  },
  head: {
    title: 'Webhooks',
  },

  async created() {
    await this.fetchWebhooksManagementUrl()
  },

  methods: {
    async fetchWebhooksManagementUrl() {
      this.isLoading = true
      try {
        const response = await ProfileAPI.get_OutboundWebhooksManagementUrl()
        this.webhooksManagementUrl = response.url
      } catch (error) {
        this.$error.emit(error)
      } finally {
        this.isLoading = false
      }
    },
  },
})
</script>

<style lang="scss">
.outbound-webhooks {
  .svix-wrapper {
    margin-top: 20px;
    border-top: $border--solid-light;
    padding-top: 20px;
    height: 80vh;
  }
}
</style>
